export default __webpack_public_path__ + "static/media/tramo.8560f7ab.svg";